import React, { useState } from 'react'
import { Loading } from './Loading'
import { MUIDataTableColumn, MUIDataTableOptions } from 'mui-datatables'
import MUIDataTable from '../../../../MuiTable'
// import MUIDataTableWithGroups from '../../../../MuiTable/MuiDataTableWithGroups'
import { Collapse, IconButton } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import { COLORES } from '../../../../../config/colores'
// import CollapsibleTable from '../../../../MuiTable/CollapsibleTable'

type DataTableWithLoadingProps = {
  title: string;
  titleColor: string;
  columns: MUIDataTableColumn[];
  data: any;
  isLoading: boolean;
  extraOptions: any;  
};

const options: MUIDataTableOptions = {
  selectableRows: "none",
  filter: true,
  filterType: "dropdown", 
  responsive: "scrollFullHeight"
};

export const MuiTableView: React.FC<DataTableWithLoadingProps> = ({
  title,
  titleColor,
  columns,
  data,
  isLoading,
  extraOptions, 
}: DataTableWithLoadingProps) => {

  const [ checked, setChecked ] = useState(true)

  const handleChange = () => {
    setChecked((prev) => !prev)
  }

  return (
    <div style={{ margin: "auto", maxWidth: "99%" }}> 
        
      {!isLoading && ( 
        (extraOptions && extraOptions.hideTitle) 
          ?          
            <MUIDataTable
              //title={title}
              data={data}
              columns={columns}
              options={{...options, ...extraOptions }}
            />
          :
            <div style={{ display:'flex', flexDirection:'column'}}>
              <IconButton onClick={handleChange} style={{ float: 'left', outline: 'none', justifyContent:'flex-start'}} className='iconbutton-muitables'>
                {checked ? <KeyboardArrowUpIcon  style={{ color: COLORES.grey.mediumDark }} /> : <KeyboardArrowDownIcon style={{ color: COLORES.grey.mediumDark }} /> }
                <h6 style={{ margin:0, padding:0, color:(titleColor ? titleColor : COLORES.grey.dark) , fontWeight:'bold'}}>{title}</h6>
              </IconButton>        

              <Collapse in={checked}>
                {/* {extraOptions && extraOptions.withGroup ?                
                  <CollapsibleTable
                    data={data}
                    columns={columns}
                    options={{ ...options, ...extraOptions }}
                    groupByColumn={extraOptions.groupByColumn}
                    calculateTotals={extraOptions.calculateTotalsGroup}
                    title={''}              
                  />                
                : */}
                <MUIDataTable
                  //title={title}
                  data={data}
                  columns={columns}
                  options={{...options, ...extraOptions }}
                />
                {/* } */}
              </Collapse>
              {!checked && <div style={{ borderBottom:'1px solid', borderColor: COLORES.grey.light, width:'90%', marginLeft:'2%' }} />}
            </div>
      )}
      {isLoading && <Loading />}
    </div>
  );
};
